require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-vogue-living-discusses-14-design-trends-for-2023-with-paul-conrad.json") })
        }
      }, "path---journal-vogue-living-discusses-14-design-trends-for-2023-with-paul-conrad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-vogue-living-discusses-14-design-trends-for-2023-with-paul-conrad!./.cache/json/journal-vogue-living-discusses-14-design-trends-for-2023-with-paul-conrad.json
// module id = 553
// module chunks = 231608221292675